import { useParams, Navigate, Outlet } from 'react-router-dom';

export default function InsightRoutesWithFileContext() {
  const { fileId } = useParams();

  if (!fileId) {
    return <Navigate to="../" />;
  }

  return <Outlet />;
}
